import { render, staticRenderFns } from "./OrderBookChart.vue?vue&type=template&id=abdbd92c"
import script from "./OrderBookChart.vue?vue&type=script&lang=js"
export * from "./OrderBookChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports